import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import PracticeAreas from "../pages/practice-areas/page";
import BrenhamLocation from "../pages/location/brenham/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/practice-areas",
    element: <PracticeAreas />,
  },
  {
    path: "/location/colorado-springs",
    element: <BrenhamLocation />,
  },
  {
    path: "/location/brenham",
    element: <BrenhamLocation />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
